/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import { DailyGroupFieldsFragmentDoc, GroupFieldsFragmentDoc } from '../../../groups/gql/_gen_/group-daily.fragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupDailyQueryVariables = Types.Exact<{
  brandCode?: Types.InputMaybe<Types.Scalars['String']>;
  startDate?: Types.InputMaybe<Types.Scalars['String']>;
  endDate?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GroupDailyQuery = { __typename?: 'Query', groupDaily?: Array<{ __typename?: 'DailyGroupData', brand_code?: string | null, date_year?: string | null, date_ym?: string | null, date_yq?: string | null, date_yw?: string | null, stay_date?: string | null, details?: Array<{ __typename?: 'Group', brand_code?: string | null, description?: string | null, group_rooms_committed?: number | null, group_rooms_remaining?: number | null, group_rooms_sold?: number | null, is_past?: boolean | null, lowest_group_rate?: number | null, rate_code?: string | null, snapshot_date?: string | null, stay_date?: string | null } | null> | null } | null> | null };

export type NewGroupKeysQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
  meetingDate: Types.Scalars['String'];
}>;


export type NewGroupKeysQuery = { __typename?: 'Query', newGroupKeys?: Array<string | null> | null };


export const GroupDailyDocument = gql`
    query GroupDaily($brandCode: String, $startDate: String, $endDate: String) {
  groupDaily(brandCode: $brandCode, startDate: $startDate, endDate: $endDate) {
    ...DailyGroupFields
    details {
      ...GroupFields
    }
  }
}
    ${DailyGroupFieldsFragmentDoc}
${GroupFieldsFragmentDoc}`;

/**
 * __useGroupDailyQuery__
 *
 * To run a query within a React component, call `useGroupDailyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupDailyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupDailyQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGroupDailyQuery(baseOptions?: Apollo.QueryHookOptions<GroupDailyQuery, GroupDailyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupDailyQuery, GroupDailyQueryVariables>(GroupDailyDocument, options);
      }
export function useGroupDailyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupDailyQuery, GroupDailyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupDailyQuery, GroupDailyQueryVariables>(GroupDailyDocument, options);
        }
export type GroupDailyQueryHookResult = ReturnType<typeof useGroupDailyQuery>;
export type GroupDailyLazyQueryHookResult = ReturnType<typeof useGroupDailyLazyQuery>;
export type GroupDailyQueryResult = Apollo.QueryResult<GroupDailyQuery, GroupDailyQueryVariables>;
export const NewGroupKeysDocument = gql`
    query NewGroupKeys($brandCode: String!, $meetingDate: String!) {
  newGroupKeys(brandCode: $brandCode, meetingDate: $meetingDate)
}
    `;

/**
 * __useNewGroupKeysQuery__
 *
 * To run a query within a React component, call `useNewGroupKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewGroupKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewGroupKeysQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      meetingDate: // value for 'meetingDate'
 *   },
 * });
 */
export function useNewGroupKeysQuery(baseOptions: Apollo.QueryHookOptions<NewGroupKeysQuery, NewGroupKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewGroupKeysQuery, NewGroupKeysQueryVariables>(NewGroupKeysDocument, options);
      }
export function useNewGroupKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewGroupKeysQuery, NewGroupKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewGroupKeysQuery, NewGroupKeysQueryVariables>(NewGroupKeysDocument, options);
        }
export type NewGroupKeysQueryHookResult = ReturnType<typeof useNewGroupKeysQuery>;
export type NewGroupKeysLazyQueryHookResult = ReturnType<typeof useNewGroupKeysLazyQuery>;
export type NewGroupKeysQueryResult = Apollo.QueryResult<NewGroupKeysQuery, NewGroupKeysQueryVariables>;
export const namedOperations = {
  Query: {
    GroupDaily: 'GroupDaily',
    NewGroupKeys: 'NewGroupKeys'
  }
}